import React from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

import { type CommentThreadDialogProps } from './thread-dialog';

export type CommentThreadDialogLazyProps = CommentThreadDialogProps;
export const CommentThreadDialogLazy = React.lazy(() =>
  getThreadDialogLazyImport().then(({ CommentThreadDialog }) => ({
    default: CommentThreadDialog,
  }))
);

export function getThreadDialogLazyImport() {
  return dynamicImport(() => import('./thread-dialog'));
}
